import { Box, FormControlLabel, styled, Typography } from '@mui/material'

export const StyledTitle = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  marginBottom: theme.spacing(1.25),
}))

export const StyledDescription = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
}))

export const StyledRadioBox = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(0.5),
  marginBottom: theme.spacing(4.5),
  '&:last-child': {
    marginBottom: theme.spacing(1.5),
  },
}))

export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  '& .MuiRadio-root': {
    padding: theme.spacing(1, 1),
  },
}))
